import Vue from 'vue';

Vue.filter('academicFullName', function (profile) {
    return `${profile?.firstName} ${profile?.lastName}, ${profile?.degree}`;
});
